<template>
  <section class="section User">
    <div class="UserBlock block-white">
      <div class="avatar-area">
        <div class="expand-button" @click="showOptionalData = true">
          <div class="avatar" :style="{ backgroundImage: 'url(' + profile.photo + ')' }">
            <span v-if="profile.photo === null" class="no-avatar">
              <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M16.4 3.34L13.66 0.6C13.3024 0.264096 12.8338 0.0713588 12.3433 0.058452C11.8529 0.0455453 11.3748 0.213369 11 0.53L1.99999 9.53C1.67676 9.85596 1.4755 10.2832 1.42999 10.74L0.999992 14.91C0.98652 15.0565 1.00553 15.2041 1.05565 15.3424C1.10578 15.4807 1.18579 15.6062 1.28999 15.71C1.38343 15.8027 1.49425 15.876 1.61609 15.9258C1.73792 15.9755 1.86838 16.0008 1.99999 16H2.08999L6.25999 15.62C6.71679 15.5745 7.14403 15.3732 7.46999 15.05L16.47 6.05C16.8193 5.68097 17.0081 5.18851 16.995 4.68054C16.9818 4.17256 16.7679 3.69051 16.4 3.34ZM6.07999 13.62L3.07999 13.9L3.34999 10.9L8.99999 5.32L11.7 8.02L6.07999 13.62ZM13 6.68L10.32 4L12.27 2L15 4.73L13 6.68Z"
                  fill="#828282" />
              </svg>
            </span>
          </div>
        </div>

        <label class="UserBlockAvatar main" for="avatar">
          <div class="avatar" :style="{ backgroundImage: 'url(' + profile.photo + ')' }">
            <span v-if="profile.photo === null" class="no-avatar">
              <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M16.4 3.34L13.66 0.6C13.3024 0.264096 12.8338 0.0713588 12.3433 0.058452C11.8529 0.0455453 11.3748 0.213369 11 0.53L1.99999 9.53C1.67676 9.85596 1.4755 10.2832 1.42999 10.74L0.999992 14.91C0.98652 15.0565 1.00553 15.2041 1.05565 15.3424C1.10578 15.4807 1.18579 15.6062 1.28999 15.71C1.38343 15.8027 1.49425 15.876 1.61609 15.9258C1.73792 15.9755 1.86838 16.0008 1.99999 16H2.08999L6.25999 15.62C6.71679 15.5745 7.14403 15.3732 7.46999 15.05L16.47 6.05C16.8193 5.68097 17.0081 5.18851 16.995 4.68054C16.9818 4.17256 16.7679 3.69051 16.4 3.34ZM6.07999 13.62L3.07999 13.9L3.34999 10.9L8.99999 5.32L11.7 8.02L6.07999 13.62ZM13 6.68L10.32 4L12.27 2L15 4.73L13 6.68Z"
                  fill="#828282" />
              </svg>
            </span>
          </div>

          <input id="avatar" hidden v-if="!isReadOnly" type="file" accept="image/jpeg, image/png"
            @change="changeAvatar" />
        </label>
      </div>


      <div class="user-optional-info" :class="{ opened: showOptionalData }" @click="showOptionalData = false">
        <div class="user-optional-info-wrapper">
          <label class="UserBlockAvatar optional" for="avatar">
            <div class="avatar" :style="{ backgroundImage: 'url(' + profile.photo + ')' }">
              <span v-if="profile.photo === null" class="no-avatar">
                <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M16.4 3.34L13.66 0.6C13.3024 0.264096 12.8338 0.0713588 12.3433 0.058452C11.8529 0.0455453 11.3748 0.213369 11 0.53L1.99999 9.53C1.67676 9.85596 1.4755 10.2832 1.42999 10.74L0.999992 14.91C0.98652 15.0565 1.00553 15.2041 1.05565 15.3424C1.10578 15.4807 1.18579 15.6062 1.28999 15.71C1.38343 15.8027 1.49425 15.876 1.61609 15.9258C1.73792 15.9755 1.86838 16.0008 1.99999 16H2.08999L6.25999 15.62C6.71679 15.5745 7.14403 15.3732 7.46999 15.05L16.47 6.05C16.8193 5.68097 17.0081 5.18851 16.995 4.68054C16.9818 4.17256 16.7679 3.69051 16.4 3.34ZM6.07999 13.62L3.07999 13.9L3.34999 10.9L8.99999 5.32L11.7 8.02L6.07999 13.62ZM13 6.68L10.32 4L12.27 2L15 4.73L13 6.68Z"
                    fill="#828282" />
                </svg>
              </span>
            </div>

            <input id="avatar" hidden v-if="!isReadOnly" type="file" accept="image/jpeg, image/png"
              @change="changeAvatar" />
          </label>

          <div class="UserBlockInfo">
            <h2 class="wrap-name">
              <span class="name">{{ profile.first_name }} {{ profile.last_name }}</span>
              <span class="role">
                <IconStudy />
                {{ capitalizeFirstLetter(profile.role) | translate }}
              </span>
            </h2>
            <div v-show="!isFree" class="birthday">
              <IconGift />
              <span class="birthdayDay">{{ profile.birthday }} </span>
              <span class="setting" @click="isReadOnly ? '' : (showModalBirthday = true)">
                <IconSetting />
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="balance-area" @click="showModalTransactionHistory = true">
        <div class="balance">
          <div class="balance-value">
            <div class="balance-icon">i$</div>

            {{ profile.indigo_dollars }}
          </div>
        </div>
      </div>

      <div class="text-center mobile-nav">
        <button class="btn btn-secondary bars" @click="openNav">
          <i class="fa fa-bars" aria-hidden="true" />
        </button>
      </div>
    </div>

    <ModalBirthday :show="showModalBirthday" @close="showModalBirthday = false" />
    <ModalTransactionsHistory :id="profile.id" :show="showModalTransactionHistory"
      @close="showModalTransactionHistory = false" />
  </section>
</template>

<script>
import Vue from 'vue'
import IconSetting from '@/components/svg/IconSetting'
import IconGift from '@/components/svg/IconGift'
import IconStudy from '@/components/svg/IconStudy'
import ModalBirthday from './Modal/Birthday.vue'
import ModalTransactionsHistory from '@/containers/Modals/TransactionsHistory.vue'
// import Character from '../../components/Games/UI/Character.vue'

export default {
  name: 'UserBlock',

  data() {
    return {
      isFree: JSON.parse(localStorage.getItem('userProfile'))?.is_free,
      Lng: {
        en: { name: 'English' },
        ru: { name: 'Русский' },
        ua: { name: 'Українська' },
        pl: { name: 'Polski' },
        he: { name: 'עברית' },
        az: { name: 'Azərbaycan' },
        hy: { name: 'հայերեն' },
        ro: { name: 'Română' },
        fr: { name: 'Français' },
        es: { name: 'Español' },
        cs: { name: 'Czech' },
        de: { name: 'Deutsch' },
      },
      languages: ['en', 'ru', 'ua', 'pl', 'he', 'az', 'hy', 'ro', 'fr', 'es', 'cs', 'de'],
      groups: [],
      showModalBirthday: false,
      showModalFeedback: false,
      showModalTransactionHistory: false,
      showNav: false,
      listOfPurchasedItems: [],
      showOptionalData: false,
      statistic: {
        today: {
          total: 0,
          right_answers: 0,
        },
        all_time: {
          total: 0,
        },
      },
    }
  },

  components: {
    IconSetting,
    IconGift,
    // IconShop,
    IconStudy,
    ModalBirthday,
    ModalTransactionsHistory,
    // Character,
  },

  props: ['openNav'],

  computed: {
    homeworkLink() {
      let link = { name: 'Dashboard Student Homework', query: {} }
      if (this.$route.query.read_only !== undefined) {
        link.query.read_only = this.$route.query.read_only
      }
      return link
    },
    profile() {
      return this.$route.query.read_only !== undefined
        ? this.$store.state.profile
        : this.$store.state.myProfile
    },
    isReadOnly() {
      return this.$route.query.read_only !== undefined
    },
    translateGroups() {
      let groups = this.groups
      let lang = this.$i18n.locale()
      if (lang === 'ua') {
        lang = 'uk'
      }
      groups.forEach(group => {
        group.name = group[`name_${lang}`]
        group.lessons.forEach(lesson => {
          lesson.name = lesson[`name_${lang}`]
        })
      })
      return groups
    },
  },

  methods: {
    onClose() {
      this.isDropdownLng = false
    },
    lng() {
      const item = localStorage.getItem('defaultLanguage')
      return this.Lng[item] && this.Lng[item].name
    },
    changeLang(locale) {
      window.localStorage.setItem('defaultLanguage', locale)
      this.isDropdownLng = !this.isDropdownLng

      this.$i18n.set(locale)
    },
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1)
    },
    changeAvatar(e) {
      let files = e.target.files

      // console.log(files[0].type)

      if (files[0].type != 'image/jpeg' && files[0].type != 'image/png') {
        console.log('incorrect file format')

        return
      }

      let photo = new FormData()
      for (var i = 0; i < files.length; i++) {
        let file = files.item(i)
        photo.append(file.name, file, file.name)
      }
      const config = {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }

      return this.axios
        .post(
          `users/user/${this.$store.state.myProfile.id}/avatar`,
          photo,
          config
        )
        .then(response => {
          let myProfile = this.$store.state.myProfile
          myProfile.photo = response.data.photo
          window.localStorage.setItem('userProfile', JSON.stringify(myProfile))
        })
    },
  },
  beforeMount() {
    if (localStorage.savedActiveItems) {
      this.listOfPurchasedItems = JSON.parse(
        localStorage.getItem('savedActiveItems')
      )
    } else {
      // console.log("Unsaved !")

      this.axios({
        url: '/eshop/items/purchased',
      })
        .then(({ data }) => {
          if (data) {
            const listOfActiveItems = data.filter(
              el => el.is_activated === true
            )

            this.listOfPurchasedItems = listOfActiveItems

            localStorage.setItem(
              'savedActiveItems',
              JSON.stringify(listOfActiveItems)
            )
          } else {
            this.listOfPurchasedItems = { error: 'Error has occurred' }
          }
        })
        .catch(() => {
          this.listOfPurchasedItems = { error: 'Error has occurred' }
        })
    }
  },
}
</script>

<style lang="scss" scoped>
$color-orange: #ffc73b;
$color-gray-light: #f2f2f2;
$color-gray: #828282;
$color-gray-dark: #4f4f4f;
$color-pink: #fa0b76;
$color-yellow: #ffd210;

.btn.bars {
  opacity: 0.7;
}

.avatar-area {
  display: flex;
  align-items: center;
}

.expand-button {
  display: none;

  @media screen and (max-width: 767px) {
    display: flex;
    align-items: center;
  }

  & svg {
    background-color: #6c757d;
    padding: 5px;
    border-radius: 50%;

    opacity: 0.7;

    margin-right: 3px;
  }
}

.user-optional-info {
  // display: flex;

  justify-content: center;
  align-items: center;

  @media (max-width: 767px) {
    display: none;

    &.opened {
      display: block;

      // background-color: #ffc73b;
      position: absolute;

      top: 0;
      right: 0;

      width: 100vw;
      height: 100vh;
    }
  }
}

.user-optional-info-wrapper {
  display: flex;
  align-items: center;

  @media (max-width: 767px) {
    background-color: #fff;

    position: absolute;

    align-items: center;

    padding: 10px;

    top: 10px;
    right: 10px;

    border-radius: 8px;
  }

}

.section {
  padding: 0px !important;
}

.notification img {
  width: 100% !important;
}

.container-balance {
  padding-top: 5px;
  display: flex;
  align-items: center;

  @media (max-width: 1200px) {
    flex-direction: column;
    align-items: flex-start;
  }

  span {
    margin-left: 3px;
  }
}

.wrap-name {
  font-weight: bold;
  font-size: 24px;
  display: flex;
  align-items: flex-start;
  margin-right: 20px;
  line-height: 140%;

  @media (max-width: 1200px) {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }
}

.name {
  max-width: 280px;
  word-wrap: break-word;
  white-space: pre-wrap;
  /* CSS3 */
  white-space: -moz-pre-wrap;
  /* Firefox */
  white-space: -pre-wrap;
  /* Opera <7 */
  white-space: -o-pre-wrap;
  /* Opera 7 */
  word-wrap: break-word;
  /* IE */
}

.balance {
  font-size: 36px;
}

.btn-shop {
  margin-left: 14px;
  background-color: $color-orange;
  color: #ffff;
  font-weight: normal;
  font-size: 12px;
  width: 82px;
  display: flex;
  justify-content: center;
  align-items: center;
  //height: 24px;
  cursor: pointer;
  line-height: 24px;
  border-radius: 4px;

  @media (max-width: 1200px) {
    margin-left: 0;
    margin-bottom: 10px;
  }

  svg {
    flex-shrink: 0;
    margin-right: 4px;
  }

  &:hover {
    color: #fff;
    text-decoration: none;
  }
}

.birthday {
  display: flex;
  align-items: center;
  height: 24px;

  &Day {
    vertical-align: baseline;
    margin: 2 !important;
    margin-top: 5px !important;

    color: $color-gray;
  }

  span {
    color: $color-gray;
  }


}

.setting {
  position: relative;
  width: 24px;
  height: 24px;
  border-radius: 10em;
  background-color: $color-gray-light;
  transition: background-color 0.35s ease-in-out;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  svg path {
    fill: $color-gray;
    transition: fill 0.35s ease-in-out;
  }

  &:hover {
    background-color: $color-gray-dark;

    svg path {
      fill: #fff;
    }
  }
}

.role {
  color: $color-pink;
  padding: 4px 10px;
  background-color: transparent;
  font-weight: normal;
  font-size: 12px;
  line-height: 140%;
  border: 1px solid $color-pink;
  border-radius: 12px;
  margin-left: 14px;
  flex-shrink: 0;

  @media (max-width: 1200px) {
    margin-left: 0;
  }

  svg {
    margin-right: 4px;

    path {
      fill: $color-pink;
    }
  }
}

.dropdownMy {
  background-color: #fff;
  display: flex;
  flex-direction: column;
  position: absolute !important;
  width: 144px;
  z-index: 1;
  box-shadow: 0 4px 16px rgba(230, 233, 243, 0.8);
  border-radius: 8px;
  padding: 14px 0;
  top: 30px;
  left: 70px;

  &Item {
    padding: 4px 12px;
    font-weight: normal;
    font-size: 16px;
    line-height: 140%;
    display: flex;
    justify-content: space-between;

    &Active {
      font-weight: bold;
    }
  }
}

.personal img {
  width: 80px;
  height: 80px;
  border-radius: 50%;
}

.header {
  background-color: #fff;
  margin: 10px;
  border-radius: 5px;
  padding: 20px;
  border: 1px solid #e2e7eb;
}

.UserHomework {
  position: relative;
}

.User {
  display: flex;
  flex: 1;

  @media (max-width: 1200px) {
    flex-direction: column;
  }

  // &Lang {
  //   &Row {
  //     position: relative;
  //     margin-top: 10px;
  //   }
  // }

  &Block {
    flex: 3;
    margin-right: 0px;
    display: flex;

    padding: 5px;

    justify-content: space-between;

    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;

    @media (max-width: 1220px) {
      margin-right: 0;
    }

    // @media (min-width: 1400px) {
    //   border-radius: 8px;
    // }

    @media (max-width: 1400px) {
      flex-direction: row-reverse;
      align-items: center;


    }

    &Avatar {
      grid-area: avatar;
      height: 80px;

      @media (max-width: 1200px) {
        flex: 2;
      }

      flex: 1;

      margin-bottom: 0 !important;

      &.optional {
        display: none;

        @media screen and (max-width: 767px) {
          display: block;
        }
      }

      &.main {
        @media screen and (max-width: 767px) {
          display: none;
        }
      }
    }

    &Info {}

    &Env {
      grid-area: env;
      margin-left: 20px;

      flex: 3;

      @media (max-width: 480px) {
        margin-left: 0;
      }
    }
  }

  &Homework {
    width: 275px;
    background-color: rgba(255, 255, 255, 0) !important;

    @media (max-width: 1200px) {
      justify-content: center;
      align-items: center;
      display: flex;
      flex-direction: column;
      margin-top: 20px;
      padding: 70px !important;
      width: auto;
      flex: 1;
    }
  }
}

.partners {
  display: flex;
  margin-top: 24px;
}

.partner {
  flex: 1;
  margin-right: 15px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.08);
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 4px 10px;

  img {
    width: 100%;
  }

  &:last-child {
    margin-right: 0;
  }
}

.btn-homework {
  width: 100%;
  height: 46px;
  display: flex;
  background-color: $color-yellow;
  color: #fff;
  justify-content: center;
  align-items: center;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.08);
  border-radius: 8px;
  font-weight: bold;
  font-size: 16px;
  line-height: 140%;

  @media (max-width: 1200px) {
    width: 250px;
  }

  &:hover {
    text-decoration: none;
    color: #fff;
  }
}

.avatar {
  width: 80px;
  height: 80px;
  background-position: center;
  background-size: cover;
  display: inline-block;
  border-radius: 50%;
  cursor: pointer;

  @media (max-width: 767px) {
    width: 60px;
    height: 60px;
  }
}

.avatar-block input[type='file'] {
  position: absolute;
  width: 80px;
  height: 80px;
  top: 0;
  left: 15px;
  cursor: pointer;
  opacity: 0;
}

.block-white {
  background-color: #fff;
  padding: 8px 30px;

  align-items: center;

  // @media (max-width: 1400px) {
  //   padding: 10px 30px 5px;
  // }
}

.no-avatar {
  background: #f2f2f2;
  border-radius: 10em;
  width: 80px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.section {
  padding: 40px 30px;
}

.inner {
  background-color: #fff;
  border-radius: 5px;
  border: 1px solid #e2e7eb;
  padding: 20px;
  height: 380px;
}

.inner .row {
  height: 100%;
}

.inner img {
  display: inline-block;
  margin-top: 30px;
  margin-bottom: 30px;
}

.inner .btn-warning {
  width: 100%;
  font-size: 20px;
  margin-top: 10px;
}

@media (max-width: 575px) {

  .header,
  .header .text-right {
    text-align: center !important;
  }
}

@media (min-width: 576px) and (max-width: 767px) {}

@media (max-width: 991px) {
  h5 {
    margin-top: 30px;
  }
}

@media (min-width: 992px) and (max-width: 1199px) {
  h5 {
    font-size: 19px;
  }
}

.balance-area {
  max-width: 1033px;

  display: flex;

  align-items: center;

  // margin-left: auto;
}

.balance {
  // width: 427px;
  // height: 363px;
  width: 100%;

  padding: 10px;

  // background: #ffffff;
  // box-shadow: 0px 15px 30px rgba(20, 35, 62, 0.15);
  border-radius: 12px;

  @media (max-width: 767px) {
    box-shadow: none;
  }
}

.balance-title {
  font-family: 'Montserrat';
  font-style: normal;
  font-weight: 700;
  font-size: 36px;
  line-height: 44px;

  color: #131a26;

  margin-bottom: 8px;

  @media (max-width: 600px) {
    font-size: 26px;
  }
}

.balance-description {
  font-family: 'Montserrat';
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 22px;

  color: #131a26;

  margin-bottom: 55px;

  @media (max-width: 600px) {
    font-size: 20px;
  }
}

.balance-icon {
  font-family: 'Montserrat';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 30px;

  text-align: center;

  color: #131a26;

  background-image: url('../../assets/shop/star.svg');
  background-repeat: no-repeat;
  background-size: contain;

  margin: auto 0;

  margin-right: 10px;

  padding: 7px 0;

  width: 40px;
  height: 40px;
}

.balance-value {
  display: flex;

  font-family: 'Montserrat';
  font-style: normal;
  font-weight: 900;
  font-size: 30px;

  color: #131a26;
}

// .exchange-logo {
// 	width: 80px;
// 	height: 80px;

// 	background-image: url('../../../assets/shop/exchange-logo.svg');
// 	background-repeat: no-repeat;
// 	background-size: cover;
// }

.balance-decoration {
  position: relative;

  width: 647px;
  height: 541px;

  margin-right: -40px;

  background-image: url('../../assets/shop/balance-decoration2.png');
  background-repeat: no-repeat;
  background-size: contain;
}

.mobile-nav {
  display: none;

  @media (max-width: 767px) {
    display: block;
  }
}
</style>

